<script setup lang="ts">
import { Bot, CalendarDays, Clapperboard, FileText, Globe } from '@lucide/vue';
import FeatureCard from '@/components/marketing/shared/FeatureCard.vue';
import SectionHeading from '@/components/marketing/shared/SectionHeading.vue';
</script>

<template>
    <section id="features" class="scroll-mt-24 py-16 sm:py-20">
        <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <SectionHeading
                eyebrow="Features"
                title="Four capabilities, one workspace."
                description="Everything your marketing needs, with the parts that are not ready yet clearly marked."
            />

            <div class="mt-12 grid gap-6 lg:grid-cols-3">
                <FeatureCard
                    class="lg:col-span-2"
                    :icon="Bot"
                    title="An AI marketing assistant for your business"
                    description="Every business gets its own assistant. It learns your products, services and tone, then remembers your feedback so the next draft needs less fixing."
                />
                <FeatureCard
                    :icon="FileText"
                    title="Content generation"
                    description="Captions, branded graphics, carousels, hashtags and calls to action, adapted for each channel."
                />
                <FeatureCard
                    :icon="Clapperboard"
                    title="AI Video Studio"
                    description="Turn raw screen recordings into narrated, captioned, professionally paced videos."
                    availability="coming-soon"
                />
                <FeatureCard
                    :icon="CalendarDays"
                    title="Publishing and scheduling"
                    description="Plan once, publish everywhere, and follow every post from draft to live."
                    tone="secondary"
                />
                <FeatureCard
                    :icon="Globe"
                    title="Website automation"
                    description="Connect a supported website so your assistant can prepare articles and page updates."
                    availability="coming-soon"
                    tone="secondary"
                />
            </div>
        </div>
    </section>
</template>
